import React, { useCallback } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";

import LoginForm from "../PopupForms/LoginForm";
import RegistrationForm from "../PopupForms/RegistrationForm";
import PasswordReset from "../PopupForms/PasswordReset";
import RegistrationNavigation from "components/common/RegistrationNavigation";
import Popup from "components/common/Popup";

import styles from "./styles.module.scss";

export const MODE = {
    LOGIN: "login",
    REGISTRATION: "registration",
    PASSWORD_RESET: "password_reset",
};

const LoginContainer = ({ previousLocation }) => {
    const navigate = useNavigate();

    const handleClose = useCallback(() => {
        navigate(previousLocation);
    }, [navigate, previousLocation]);

    return (
        <Popup onClose={handleClose}>
            <div className={styles.popup}>
                <Routes>
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/registration" element={<RegistrationForm />} />
                    <Route path="/forgot" element={<PasswordReset />} />
                </Routes>
                <RegistrationNavigation />
            </div>
        </Popup>
    );
};

export default LoginContainer;
